import { PortfolioTaskStatus } from "api/generated";
import { PORTFOLIO_ROUTE_NAMES } from "portfolio/routes/routeNames";

/**
 * The two tabs of the teacher's task overview, keyed by their route. A tab is
 * a fixed status selection: "Openstaand" holds everything that is not over yet
 * (drafts, planned and open tasks), "Afgerond" holds tasks whose deadline has
 * passed. The status filter is left out of the filter panel on this page, so
 * the tab is the only thing that decides the statuses sent.
 */
export const SCHEDULED_TASK_TAB_STATUSES = {
  [PORTFOLIO_ROUTE_NAMES.TEACHER_OPEN_SCHEDULED_TASKS]: [
    PortfolioTaskStatus.concept,
    PortfolioTaskStatus.planned,
    PortfolioTaskStatus.open,
  ],
  [PORTFOLIO_ROUTE_NAMES.TEACHER_COMPLETED_SCHEDULED_TASKS]: [
    PortfolioTaskStatus.closed,
  ],
} as const satisfies Record<string, readonly PortfolioTaskStatus[]>;

export type ScheduledTaskTabRouteName =
  keyof typeof SCHEDULED_TASK_TAB_STATUSES;

/** The filter the tabs replace; it is stripped from the panel and the query. */
export const SCHEDULED_TASK_STATUS_FILTER_NAME = "status";
